import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingRows: React.FC<{ count?: number; label?: string }> = ({ count = 5, label = 'Loading records' }) => (
  <div role="status" aria-label={label} className="divide-y divide-gray-100">
    <span className="sr-only">{label}</span>
    {Array.from({ length: count }, (_, index) => (
      <div key={index} aria-hidden="true" className="p-6 space-y-3 motion-safe:animate-pulse">
        <div className="h-5 w-2/3 rounded bg-gray-200" />
        <div className="h-4 w-1/2 rounded bg-gray-100" />
        <div className="h-3 w-1/3 rounded bg-gray-100" />
      </div>
    ))}
  </div>
);
export const LoadingValue = () => <span role="status" aria-label="Loading total" className="block h-8 w-16 rounded bg-gray-200 motion-safe:animate-pulse" />;
export const UpdatingIndicator = () => <span role="status" className="inline-flex items-center gap-2 text-xs text-gray-500"><Loader2 aria-hidden="true" className="h-3 w-3 motion-safe:animate-spin" />Updating…</span>;
export const SectionError: React.FC<{ onRetry: () => void; message?: string; retryLabel?: string }> = ({ onRetry, retryLabel = 'Retry', message = 'Unable to load this section.' }) => (
  <div role="alert" className="p-4 text-sm text-red-700 flex items-center gap-3 flex-wrap">
    <span>{message}</span><button type="button" onClick={onRetry} className="underline font-medium">{retryLabel}</button>
  </div>
);
export const PageSkeleton = () => (
  <div className="mx-auto w-full max-w-7xl px-6 py-8"><div aria-hidden="true" className="mb-6 h-9 w-52 bg-gray-200 rounded motion-safe:animate-pulse" /><LoadingRows label="Loading page" /></div>
);
